const LocationIcon = '/assets/trrass/general/LocationIcon.svg';
const PhoneIcon = '/assets/trrass/general/PhoneIcon.svg';
const HeaderLogo = '/assets/trrass/general/Header-Logo.svg';
const FooterLogo = '/assets/trrass/general/Footer-Logo.svg';
const ContactBg = '/assets/trrass/home/home-background.jpg';
const PopupIcon = '/assets/tepual/gallery/gallery5.jpg';
const BookingActive = '/assets/trrass/home/BuyTicketIcon-Active.svg';
const BookingInActive = '/assets/trrass/home/BuyTicketIcon-Inactive.svg';
const CancelActive = '/assets/trrass/home/CancelTicketIcon-Active.svg';
const CancelInActive = '/assets/trrass/home/CancelTicketIcon-Inactive.svg';
const OriginIcon = '/assets/trrass/home/SearchBar-OriginIcon.svg';
const DestinationIcon = '/assets/trrass/home/SearchBar-DestinationIcon.svg';
const CalendarIcon = '/assets/trrass/home/SearchBar-CalendarIcon.svg';
const SearchIcon = '/assets/trrass/home/SearchBar-SearchIcon.svg';
const checkboxIcon = '/static/images/icons/BusOperatorsWebsite-Checkbox.png';
const BottomFooterKuposLogo = '/assets/common/Footer-kuposLogo.svg';
const animation = '/static/images/animations/Services-kupos-PasajeBus-Orange.gif';
const pnr = '/assets/trrass/home/WhereToFindMyPNR.svg';

const contactMail = '/assets/trrass/contact/contact-email-icon.svg';
const contactHeadphone = '/assets/trrass/contact/contact-phone-number-icon.svg';
const aboutUsImage = '/assets/trrass/about-us/single-bus-about-us.jpg';

// banners
const destinationBanner = '/assets/trrass/destinations/destination-main.jpg';
const galleryBanner = '/assets/trrass/gallery/MainBanner-Gallery.jpg';
const contactUsBanner = '/assets/trrass/contact/contact-us-banner.jpg';
const aboutUsBanner = '/assets/trrass/about-us/MainBanner-AboutUs.jpg';
const tncBanner = '/assets/trrass/tnc/banner-tnc.jpg';
const officeBanner = '/assets/trrass/offices/offices-banner.jpg';

const OfficePhoneIcon = '/assets/trrass/offices/Offices-PhoneNumberIco.svg';
const success = '/assets/bahia/Blue/MyAccount-IllustratedIcons-CheckMark-Blue.svg';
const failure = '/assets/bahia/Blue/MyAccount-IllustratedIcons-Information-Blue.svg';

const tick = '/assets/bahia/Blue/MyAccount-IllustratedIcons-Tick-Blue.svg';
const heartOn = '/assets/bahia/Blue/MyAccount-IllustratedIcons-HeartOn-Blue.svg';
const heartOff = '/assets/bahia/Blue/MyAccount-IllustratedIcons-HeartOff-Blue.svg';
const downArrow = '/assets/bahia/Blue/MyAccount-IllustratedIcons-DropDown-Blue.svg';
const registrationSuccess = '/assets/bahia/Blue/MyAccount-IllustratedIcons-RightDocument-Blue.svg';
const userIcon = '/assets/bahia/Home/user_red_dot-BahiaAzul.svg';
const trips = '/assets/bahia/Blue/MyAccount-IllustratedIcons-MyTrips-Blue.svg';
const cards = '/assets/bahia/Blue/MyAccount-IllustratedIcons-MyCards-Blue.svg';
const wallet = '/assets/bahia/Blue/MyAccount-IllustratedIcons-RechargeWallet-Blue.svg';
const transaction = '/assets/bahia/Blue/MyAccount-IllustratedIcons-ShareMoney-Blue.svg';
const otp = '/assets/bahia/Blue/MyAccount-IllustratedIcons-RestorePassword-Blue.svg';

const paso_1 = '/assets/bahia/Blue/MyAccount-IllustratedIcons-RechargeWallet-Blue.svg';
const paso_2 = '/assets/bahia/Blue/MyAccount-IllustratedIcons-RechargePoints-Blue.svg';
const paso_3 = '/assets/bahia/Blue/MyAccount-IllustratedIcons-ID-Blue.svg';
const paso_4 = '/assets/bahia/Blue/MyAccount-IllustratedIcons-Tickets-Blue.svg';

const petseatref = '/assets/trrass/icons/petseat-icon.png';
const petseatModal = '/assets/trrass/icons/popup-mascotas-no-button.png';
const petfilteroff = '/assets/traveltur/pet/PetsOnBoard-Button-Filter_Off.png';
const petfilteron = '/static/images/seats/On-Button-Filter.svg';

const trrassIcons = [

  { icon: downArrow, name: 'downArrow' },
  { icon: userIcon, name: 'userIcon' },
  { icon: trips, name: 'trips' },
  { icon: cards, name: 'cards' },
  { icon: wallet, name: 'wallet' },
  { icon: transaction, name: 'transaction' },
  { icon: success, name: 'success' },
  { icon: failure, name: 'failure' },
  { icon: tick, name: 'tick' },
  { icon: heartOn, name: 'heartOn' },
  { icon: heartOff, name: 'heartOff' },
  { icon: registrationSuccess, name: 'registrationSuccess' },
  { icon: otp, name: 'otp' },

  { icon: paso_1, name: 'paso_1' },
  { icon: paso_2, name: 'paso_2' },
  { icon: paso_3, name: 'paso_3' },
  { icon: paso_4, name: 'paso_4' },

  { icon: PhoneIcon, name: 'phone' },
  { icon: LocationIcon, name: 'location' },
  { icon: HeaderLogo, name: 'headerLogo' },
  { icon: FooterLogo, name: 'footerLogo' },
  { icon: ContactBg, name: 'ContactBg' },
  { icon: BookingInActive, name: 'BIA' },
  { icon: BookingActive, name: 'BA' },
  { icon: success, name: 'success' },
  { icon: failure, name: 'failure' },
  { icon: CancelInActive, name: 'CIA' },
  { icon: CancelActive, name: 'CA' },
  { icon: OriginIcon, name: 'Origin' },
  { icon: DestinationIcon, name: 'Destination' },
  { icon: CalendarIcon, name: 'Calendar' },
  { icon: SearchIcon, name: 'Search' },
  { icon: PopupIcon, name: 'Popup' },
  { icon: checkboxIcon, name: 'Checkbox' },
  { icon: BottomFooterKuposLogo, name: 'BottomFooterKuposLogo' },
  { icon: animation, name: 'animation' },
  { icon: pnr, name: 'pnr' },
  { icon: OfficePhoneIcon, name: 'OfficePhoneIcon' },

  { icon: contactMail, name: 'contactMail' },
  { icon: contactHeadphone, name: 'contactHeadphone' },
  { icon: destinationBanner, name: 'destinationBanner' },
  { icon: galleryBanner, name: 'galleryBanner' },
  { icon: contactUsBanner, name: 'contactUsBanner' },
  { icon: aboutUsImage, name: 'aboutUsImage' },
  { icon: aboutUsBanner, name: 'aboutUsBanner' },
  { icon: tncBanner, name: 'tncBanner' },
  { icon: officeBanner, name: 'officeBanner' },

  { icon: petseatref, name: 'petseatref' },
	{ icon: petseatModal, name: 'petseatModal' },
	{ icon: petfilteron, name: 'petfilteron' },
	{ icon: petfilteroff, name: 'petfilteroff' },
];

export default trrassIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/trrassIcons.js